import { RotationCargoOperationBM } from 'src/types/BusinessModel/Stowage/Rotation/RotationCargoOperationBM';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';

export const createRotationCargoOperation = (cargoOperationBM: RotationCargoOperationBM, berthCall: RotationBerthCall): RotationCargoOperation => {
    return {
        cargoOperationGuid: crypto.randomUUID(),
        berthCallGuid: berthCall.berthCallGuid,
        portCallGuid: berthCall.portCallGuid,
        cargoGuid: null,
        imosCargoOperationId: cargoOperationBM.cargoOperationId,
        imosCargoId: cargoOperationBM.cargo.cargoId,
        berthCall: berthCall,
        cargo: null,
        cargoOperationSequenceNumber: cargoOperationBM.cargoOperationSequenceNumber,
        billOfLadingWeight: cargoOperationBM.billOfLadingWeight > 0 ? cargoOperationBM.billOfLadingWeight : null,
        dataSource: cargoOperationBM.dataSource,
        contractWeight: cargoOperationBM.nominatedWeight, // This is not an error, the contract weight is returned in the field nominatedWeight by the RotationApi
        nominatedWeight: cargoOperationBM.operationType === 'Transfer' ? cargoOperationBM.nominatedWeight : null,
        operationType: cargoOperationBM.operationType,
        demurrageRatePerDay: cargoOperationBM.demurrageRatePerDay,
        pumpingRatePerHour: cargoOperationBM.pumpingRatePerHour,
        cpDate: cargoOperationBM.cpDate,
    };
};

export const createRotationCargoOperationList = (cargoOperationBMList: RotationCargoOperationBM[], berthCall: RotationBerthCall) =>
    cargoOperationBMList.map((cargoOperation) => createRotationCargoOperation(cargoOperation, berthCall));
